import React from "react";
import { useTheme } from "../context/ThemeContext";
import { Moon, Sun } from "lucide-react";
import { Button } from "./ui/button";

export const ThemeToggle = ({ variant = "icon", className = "" }) => {
  const { theme, toggleTheme } = useTheme();

  if (variant === "icon") {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleTheme}
        className={`text-muted-foreground hover:text-foreground ${className}`}
        data-testid="theme-toggle-btn"
        aria-label={theme === "dark" ? "Zu hellem Modus wechseln" : "Zu dunklem Modus wechseln"}
      >
        {theme === "dark" ? (
          <Sun className="w-5 h-5" />
        ) : (
          <Moon className="w-5 h-5" />
        )}
      </Button>
    );
  }

  // Full button variant with text
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleTheme}
      className={className}
      data-testid="theme-toggle-btn"
    >
      {theme === "dark" ? (
        <>
          <Sun className="w-4 h-4 mr-2" />
          Hell
        </>
      ) : (
        <>
          <Moon className="w-4 h-4 mr-2" />
          Dunkel
        </>
      )}
    </Button>
  );
};

export default ThemeToggle;
